module.exports = __webpack_public_path__ + "img/435335235.6672abf5.png";